import React, {useState} from 'react';
import {Button, Col, Layout, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import img1 from './imgs/NEW_Infographic without circles.webp'
import './style.scss'
import {SFW_TEXT} from "./text";
import img2 from './imgs/img.png'
import img3 from './imgs/UPDATED_01.webp'
import img_1 from './imgs/img_1.png'
import img_2 from './imgs/img_2.png'
import img_3 from './imgs/img_3.png'
import img_4 from './imgs/img_4.png'
import qrcode from './imgs/qr-code-temp.png'

const Software = (props) => {
    const [hoverText, setHoverText] = useState(null);

    const circles = [
        {
            id: 'art-library', label: 'Explore our ART LIBRARY',
            text: (
                <p>
                    Explore the Vieunite Pro <span style={{fontWeight: "bold"}}>Art Library</span>, where you can find
                    art of every genre. Fully transform your business surrounding with timeless classic pieces or fresh
                    contemporary artwork.
                </p>
            ),
        },
        {
            id: 'curated-collections', label: 'View exquisite CURATED COLLECTIONS', text: (
                <p>
                    Our Curated Collections are meticulously selected by our in-house
                    experts and feature works from world-renowned art galleries. Alternatively, you can work directly
                    with Vieunite Artists, a selective group of creatives who show incredible potential.
                </p>
            ),
        },
        {
            id: 'image-video-upload', label: 'Upload VIDEO CONTENT and IMAGES', text: (
                <p>
                    With Textura Pro, you can curate your personal gallery by uploading your own content.
                    Our digital canvas seamlessly displays both static images and video content, ensuring an immersive
                    viewing experience for your customers.
                </p>
            ),
        },
        {
            id: 'playlists', label: 'CREATE PLAYLISTS', text: (
                <p>
                    Fully personalise your business spaces by creating playlists for each Textura digital canvas and
                    categorising them by colour scheme, theme, artist or genre.
                </p>
            )
        },
        {
            id: 'manage-devices', label: 'MANAGE DEVICES', text: (
                <p>
                    With the Vieunite Pro Portal you can easily manage your digital canvases no matter when or where.
                    Take advantage of the flexibility that our software offers and make each business location truly
                    unique for your customers.
                </p>
            )
        },
        {
            id: 'art-market', label: 'Connect with a thriving ART MARKET', text: (
                <p>
                    Vieunite Pro gives you exclusive access to our Art Market, a space where you can buy specific pieces
                    of art or request commission bespoke artwork for your businesses.
                    This market connects you with our Vieunite Artists, giving you the opportunity to support them
                    directly.
                </p>
            )
        },
    ];
    return (
        <Layout>
            <Content>
                <Row justify={"center"}
                     style={{
                         margin: '8rem 0 0 0',
                         display: "flex",
                         flexDirection: "column",
                         alignItems: "center",
                         justifyContent: "center"
                     }}
                >
                    <p className={'sfw-head'}>
                        Take control
                    </p>
                    <p className={'sfw-subhead'}>
                        of what you display with our intuitive software
                    </p>
                </Row>
                <Row justify={"center"}>
                    <Col lg={20} className={'sfw-circle-col'}>
                        <img src={img1} className={'backgroundImage'}/>
                        {circles.map((circle) => (
                            <div
                                key={circle.id}
                                className={`circle ${circle.id}`}
                                onMouseEnter={() => setHoverText(circle.text)}
                                onMouseLeave={() => setHoverText(null)}
                                style={{fontSize:'0.675vw'}}
                            >{circle.label}</div>
                        ))}
                        <div className="center-text">{hoverText}</div>
                    </Col>
                </Row>
                <Row justify={"center"}>
                    <Button className={'sft-btn-portal pro-btn-hover-to-white'}
                            onClick={() => {
                                window.location.href = '/business/prologin'
                            }}
                    >
                        Explore the Vieunite Portal
                    </Button>
                </Row>

                <Row justify={"center"} style={{margin: '4rem 0 0 0'}}>
                    <Col lg={10} className={'sfw-img-col'}>
                        <p className={'sfw-small-title'}> Discover Art</p>
                        <img src={img_1} style={{width: '35vw'}}/>
                        <p className={'sfw-small-txt'}>{SFW_TEXT['Discover Art']}</p>
                    </Col>
                    <Col lg={10} className={'sfw-img-col'}>
                        <p className={'sfw-small-title'}>Organise your content</p>
                        <img src={img_2} style={{width: '35vw'}}/>
                        <p className={'sfw-small-txt'}>{SFW_TEXT['My Library']}</p>
                    </Col>
                </Row>
                <Row justify={"center"}>
                    <Col lg={10} className={'sfw-img-col'}>
                        <p className={'sfw-small-title'}>Take control of your hardware </p>
                        <img src={img_3} style={{width: '35vw'}}/>
                        <p className={'sfw-small-txt'}>{SFW_TEXT.Dashboard}</p>
                    </Col>
                    <Col lg={10} className={'sfw-img-col'}>
                        <p className={'sfw-small-title'}>Manage accounts and settings</p>
                        <img src={img_4} style={{width: '35vw'}}/>
                        <p className={'sfw-small-txt'}>{SFW_TEXT["Account"]}</p>
                    </Col>
                </Row>
                <Row justify={"center"}>
                    <Col lg={20}>
                        <div className="image-container">
                            <img src={img3} alt="Background"
                                 className="background-image"
                                 style={{
                                     width:'76vw',
                                     // height:'80vh'
                                     margin:"2rem auto 8rem auto"
                                 }}
                            />
                            <div className="sfw-content">
                                <p className={'content-head'} style={{marginBottom: '6vh'}}>The Pairing App</p>
                                <p className={'content-txt'}>
                                    An easy-to-use app has been designed specifically for connecting hardware devices.
                                    Its functions include pairing the portal with hardware devices, changing the names
                                    of the  hardware, removing hardware, and providing quick control to switch the
                                    hardware on/off.
                                </p>
                                <p className={'content-txt'} style={{fontWeight: "bold"}}>
                                    Use the QR code below to be taken to the app store for your device
                                </p>
                                <Row justify={"center"}
                                     style={{
                                         margin: '-12vh 0 0 -2.6vw',
                                         width: '24vw'
                                     }}
                                >
                                    <Col lg={10}>
                                        <img
                                            style={{
                                                'width': '7.2vw', 'height': '7.2vw'
                                            }}
                                            alt={'qrcode'}
                                            src={qrcode}
                                        />

                                    </Col>
                                    <Col lg={10} style={{marginLeft:'-1.2vw'}}>
                                        <Button className={'content-btn pro-btn-hover-to-white'}
                                                onClick={_ => window.location.href = '/app.html'}
                                                style={{
                                                    width: '12vw',
                                                    height: '5vh',
                                                    fontSize: '1.1vw',
                                                    margin: '0vh 0 6vh 0 '
                                                }}
                                        >
                                            iOS App Store
                                        </Button>
                                        <Button className={'content-btn pro-btn-hover-to-white'}
                                                onClick={_ => window.location.href = '/app.html'}
                                                style={{
                                                    width: '12vw',
                                                    height: '5vh',
                                                    fontSize: '1vw',
                                                }}
                                        >
                                           Android coming soon
                                        </Button>
                                    </Col>
                                </Row>

                            </div>
                        </div>
                    </Col>
                </Row>
            </Content>
        </Layout>
    )
}

export default Software;
